// src/Modal.js
import React from "react";

export default function Modal({ isOpen, onClose, title, children }) {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="modal-overlay"
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.6)",
          zIndex: 1000,
        }}
      />
      <div
        className="modal-content"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "var(--dark3)",
          border: "1px solid var(--border)",
          borderRadius: "8px",
          padding: "2rem",
          maxWidth: "500px",
          width: "90%",
          zIndex: 1001,
          color: "var(--text)",
          boxShadow: "0 0 20px var(--gold)",
          overflowY: "auto",
          maxHeight: "70vh",
        }}
      >
        <h3
          id="modal-title"
          style={{
            marginBottom: "1rem",
            color: "var(--gold)",
            fontFamily: "var(--font-head)",
          }}
        >
          {title}
        </h3>
        <div>{children}</div>
        <button
          onClick={onClose}
          className="btn"
          style={{ marginTop: "1.5rem", display: "block", marginLeft: "auto" }}
        >
          Close
        </button>
      </div>
    </>
  );
}
